module.exports = __webpack_public_path__ + "static/img/adaptivity.c347124.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gameDetails/UnderdogDetective/top/adaptivity.jpg
// module id = XPz2
// module chunks = 0